import React from 'react'
import PropTypes from 'prop-types'
import SearchForm from './../../shared/components/searchForm/SearchForm';
import { roleSearchFields } from '../utils/searchFields';
import DataTable from './../../shared/components/table/DataTable';
import { I18n } from 'react-redux-i18n';
import { appModules } from './UserHasPermission';

const RolesPage = ({
    searchFieldsValues,
    universalSearchField,
    handleSearchFieldChange,
    handleUniversalSearchFieldChange,
    handleSearchSubmit,
    handleSearchClear,
    handleSortChanged,
    handleAddButtonClicked,
    entityList = [],
    data = [],
    pages = 0,
    currentPage = 0,
    pageSize,
    totalElements,
    sort: {
        property = "",
        direction = "ASC"
    },
    onRowClick,
    onPageChange,
    onPageSizeChange,
}) => {

    const columns = [{
        Header: I18n.t("roles.list.name"),
        accessor: "name",
        sortable: true
    }, {
        Header: I18n.t("roles.list.entity"),
        id: "entityName",
        accessor: role => role.entity.name,
        sortable: true
    }];

    return <div className="page_background">
        <SearchForm
            content={roleSearchFields(searchFieldsValues, entityList)}
            universalSearchField={universalSearchField}
            handleFieldChange={handleSearchFieldChange}
            handleUniversalSearchFieldChange={handleUniversalSearchFieldChange}
            handleClear={handleSearchClear}
            handleSubmit={handleSearchSubmit}
            handleAddButtonClicked={handleAddButtonClicked}
            appModule={appModules.ROLE}
        />
        <div>
            <DataTable
                //State dependent
                data={data}
                onRowClick={onRowClick}

                //Pagination
                pages={pages}
                selectedPage={currentPage}
                pageSize={pageSize}
                sortDirection={direction}
                sortProperty={property}
                totalElements={totalElements}
                pageSizeOptions={[10, 20, 50]}
                onPageChange={onPageChange}
                onPageSizeChange={onPageSizeChange}
                onSortChanged={handleSortChanged}

                //State independent / Configuration
                columns={columns}
                hasStatusBar={false}
            />
        </div>
    </div>
}

RolesPage.propTypes = {
    searchFieldsValues: PropTypes.object.isRequired,
    handleSearchFieldChange: PropTypes.func,
    handleSearchSubmit: PropTypes.func,
    handleSearchClear: PropTypes.func,
    entityList: PropTypes.array,
    data: PropTypes.array,
    pages: PropTypes.number,
}


export default RolesPage;

